import React from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { SeoPageLayout } from "./SeoPageLayout";
import { OratoriaVideoPT } from "./content/oratoria-video/pt";
import { OratoriaVideoEN } from "./content/oratoria-video/en";
import { OratoriaVideoES } from "./content/oratoria-video/es";

interface Props {
    onLaunch: () => void;
}

export const OratoriaVideo: React.FC<Props> = ({ onLaunch }) => {
    const { lang } = useTranslation();

    let Content = OratoriaVideoPT;
    let title = lang === "pt" ? "Oratória em Vídeo: 5 Dicas para Perder o Medo e Falar Bem (com Teleprompter Ninja)" : "5 Dicas de Oratória em Vídeo que VÃO te Fazer Parar de Regravar";
    let description = lang === "pt" ? "Melhore sua oratória em vídeo hoje mesmo! Aprenda técnicas simples para falar com naturalidade, manter o contato visual e transmitir autoridade usando o teleprompter PromptNinja. Comece seu treino grátis." : "Pare de travar e perder tempo! 5 técnicas rápidas para falar bem no vídeo. Bônus: Teleprompter GRÁTIS para aplicar a técnica instantaneamente.";
    let canonicalUrl = "https://promptninja.solutionkit.com.br/dicas-oratoria-video";


    let ogImage = "https://promptninja.solutionkit.com.br/og-image.webp";
    let schema: object = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": title,
        "description": description,
        "url": canonicalUrl,
        "image": ogImage,
        "author": {
            "@type": "Organization",
            "name": "PromptNinja",
            "url": "https://promptninja.solutionkit.com.br"
        }
    };
    let ctaText = "Praticar com Teleprompter Grátis";
    let ctaSubText = "Comece a gravar vídeos profissionais hoje mesmo.";

    if (lang === 'en') {
        Content = OratoriaVideoEN;
        title = "Master Public Speaking for Videos: Speak with Confidence | PromptNinja";
        description = "Stop freezing or sounding insecure. 5 fast techniques to speak well on video. Plus: discover how our FREE teleprompter applies these techniques instantly.";
        canonicalUrl = "https://promptninja.solutionkit.com.br/en/public-speaking-tips-video";
        ogImage = "https://promptninja.solutionkit.com.br/og-image.webp";
        schema = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": title,
            "description": description,
            "url": canonicalUrl,
            "image": ogImage,
            "author": {
                "@type": "Organization",
                "name": "PromptNinja",
                "url": "https://promptninja.solutionkit.com.br/?lang=en"
            }
        };
        ctaText = "Practice with Free Teleprompter";
        ctaSubText = "Start recording professional videos today.";
    } else if (lang === 'es') {
        Content = OratoriaVideoES;
        title = "Consejos de Oratoria para Video: Cómo Hablar con Confianza";
        description = "Mejora tu presencia frente a las cámaras. Aprende técnicas de oratoria y descubre cómo el teleprompter puede ayudar a eliminar las muletillas de tus videos.";
        canonicalUrl = "https://promptninja.solutionkit.com.br/es/consejos-oratoria-video";
        ogImage = "https://promptninja.solutionkit.com.br/og-image.webp";
        schema = {
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": title,
            "description": description,
            "url": canonicalUrl,
            "image": ogImage,
            "author": {
                "@type": "Organization",
                "name": "PromptNinja",
                "url": "https://promptninja.solutionkit.com.br/?lang=es"
            }
        };
        ctaText = "Practicar con Teleprompter Gratis";
        ctaSubText = "Empieza a grabar videos profesionales hoy mismo.";
    }

    return (
        <SeoPageLayout
            title={title}
            description={description}
            canonicalUrl={canonicalUrl}
            ogImage={ogImage}
            schema={schema}
            onLaunch={onLaunch}
        >
            <Content />

            <div className="mt-12 text-center">
                <button
                    onClick={onLaunch}
                    className="bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 text-white font-bold py-4 px-8 rounded-lg text-lg shadow-2xl hover:scale-105 transition transform duration-200"
                >
                    {ctaText}
                </button>
                <p className="mt-4 text-sm text-slate-500">{ctaSubText}</p>
            </div>
        </SeoPageLayout>
    );
};
